import React, { Component, useState, useEffect } from "react";
//import { Draggable } from "react-drag-reorder";
import { Multiselect } from "multiselect-react-dropdown";
import {
  Row,
  Card,
  Col,
  Button,
  Nav,
  Modal,
  Table,
  Dropdown,
  Alert,
  Spinner,
} from "react-bootstrap";
import swal from "sweetalert";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
var FormData = require("form-data");
var fs = require("fs");
export default function Training() {
  const history = useHistory();
  const [url, setUrl] = useState("");
  const [header, setHeader] = useState("");
  const [description, setDescription] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [name, setName] = useState("");
  const [catList, setCatList] = useState([]);
  const [training, setTraining] = useState("");
  const [image, setImage] = useState(null);
  const [imageData, setImageData] = useState(null);
  const [show, setShow] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(false);
  const [bannerId, setBannerId] = useState("");
  const [bannerImageKey, setBannerImageKey] = useState("");
  const searchObject = ["Rider", "Onboard"];
  const [type, setType] = useState("Rider");
  const handleShow = () => {
    setUpdateStatus(false);
    setShow(true);
    setDeleteStatus(false);
    setUrl("");
    setDescription("");
    setHeader("");
    setImageData(null);
  };
  const handleClose = () => {
    setShow(false);
  };
  function getData() {
    axios
      .get(Baseurl.baseurl + `/rider/get-academy`)
      .then((res) => {
        setSpinner(false);
        setTraining(res.data.details);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function getCategory() {
    let cat = [];
    axios
      .get(Baseurl.baseurl + `/rider/get-category`)
      .then((res) => {
        res.data.categories.map((val) => {
          cat.push({ category: val.Category, title: val.Category });
        });
        cat.push({ category: "others", title: "Others" });
        setCatList(cat);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  useEffect(() => {
    getData();
    // getCategory();
  }, []);
  const onChangePicture = (e) => {
    if (e.target.files[0] && e.target.files[0].size / 1024 < 200) {
      if (e.target.files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function (val) {
          var image = new Image();
          image.src = val.target.result;
          image.onload = function () {
            var height = this.height;
            var width = this.width;
            setImage(e.target.files[0]);
            setImageData(reader.result);
            // if (height == 400 && width == 800) {
            // setImage(e.target.files[0]);
            // setImageData(reader.result);
            // } else {
            //   swal("Oops", "image Width×Height should be 800×400", "error", {
            //     button: "Done",
            //     timer: 2000,
            //   });
            //   setImageData(null);
            //   return false;
            // }
          };
        };
      }
    } else {
      swal("Oops", "image size should be less than 200KB", "error", {
        button: "Done",
        timer: 2000,
      });
      setImageData(null);
    }
  };

  function saveBanner(e) {
    e.preventDefault();
    const data = new FormData();
    data.append("header", `${header}`);
    data.append("image", image);
    data.append("url", `${url}`);
    data.append("to", `${type}`);
    data.append("description", `${description}`);
    var config = {
      method: "post",
      url: `${Baseurl.baseurl}/rider/create-academy`,
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status) {
          getData();
          setName("");
          setImage(null);
          setImageData(null);
          setUrl("");
          setDescription("");
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });

    handleClose();
  }
  function deleteBanner(e) {
    e.preventDefault();
    axios
      .delete(Baseurl.baseurl + `/rider/delete-academy/${bannerId}`)
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        handleClose();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function updateImage(e) {
    e.preventDefault();
    const data = new FormData();
    data.append("image", image);
    data.append("imageKey", bannerImageKey);
    var config = {
      method: "put",
      url: `${Baseurl.baseurl}/rider/update-academy-image/${bannerId}`,
      data: data,
    };
    axios(config)
      .then(function (response) {
        if (response.data.status) {
          getData();
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });

    handleClose();
  }
  function updateFields(val) {
    let bannerData = [];
    if (val === "header") {
      bannerData = {
        header: header,
      };
    } else if (val === "desc") {
      bannerData = {
        description: description,
        //to
      };
    } else if (val === "url") {
      bannerData = {
        url: url,
      };
    }
    axios
      .put(
        Baseurl.baseurl +
          `/rider/update-academy-${
            val === "header" ? "header" : val === "desc" ? "description" : "url"
          }/${bannerId}`,
        bannerData
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }
  return (
    <Card>
      <Modal show={show} onHide={handleClose}>
        <Modal.Body>
          {deleteStatus ? (
            <h4>Are you sure !! you want to delete</h4>
          ) : (
            <div>
              <div>
                <div className="basic-form">
                  <div className=" mb-3 " id="multiselect">
                    <label>Header</label>
                    <div className="row">
                      <input
                        value={header}
                        type="text"
                        className="form-control col-sm-8"
                        placeholder="enter header"
                        onChange={(e) => setHeader(e.target.value)}
                        required
                      />
                      {updateStatus && (
                        <button
                          onClick={() => {
                            updateFields("header");
                          }}
                          className="btn btn-primary col-sm-2 ml-3"
                        >
                          Update
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <div className=" mb-3">
                  <label>Description</label>
                  <div className="row">
                    <input
                      value={description}
                      type="text"
                      className="form-control col-sm-8"
                      placeholder="enter Description"
                      onChange={(e) => setDescription(e.target.value)}
                      required
                    />
                    {updateStatus && (
                      <button
                        onClick={() => {
                          updateFields("desc");
                        }}
                        className="btn btn-primary col-sm-2 ml-3"
                      >
                        Update
                      </button>
                    )}
                  </div>
                </div>
                {!updateStatus&&(
                  <div className=" mb-3">
                  <label>Type</label>

                  <select
                    className="form- col-sm-12 text-primary p-2"
                    id="val-skill"
                    name="val-skill"
                    placeholder="Select Search Item"
                    defaultValue={type}
                    onChange={(event) => {
                      setType(event.target.value);
                    }}
                  >
                    {searchObject &&
                      searchObject.map((val) => (
                        <option value={val}>{val}</option>
                      ))}
                  </select>
                </div>
                )}
                
                <div className=" mb-3">
                  <label>Url</label>
                  <div className="row">
                    <input
                      value={url}
                      type="text"
                      className="form-control col-sm-8"
                      placeholder="enter url"
                      onChange={(e) => setUrl(e.target.value)}
                      required
                    />
                    {updateStatus && (
                      <button
                        onClick={() => {
                          updateFields("url");
                        }}
                        className="btn btn-primary col-sm-2 ml-3"
                      >
                        Update
                      </button>
                    )}
                  </div>
                </div>

                <div className="col-sm-12">
                  <div className="form-group row">
                    <label
                      className="col-sm-4 col-form-label"
                      htmlFor="val-range"
                    >
                      Image
                      <span className="text-danger">*</span>
                    </label>

                    <div className="col-lg-8">
                      <div className="row">
                        <div classname="col-sm-4">
                          <div className="register_profile_image mt-2">
                            <input
                              id="profilePic"
                              type="file"
                              onChange={(e) => {
                                onChangePicture(e);
                              }}
                            />
                          </div>
                          <small>
                            image should be less than 200KB and size 800×400
                          </small>
                          {imageData && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="previewProfilePic row"
                            >
                              <img
                                alt=""
                                className="playerProfilePic_home_tile "
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                src={imageData}
                              />
                            </div>
                          )}
                          {updateStatus && (
                            <button
                              onClick={(e) => {
                                updateImage(e);
                              }}
                              className="btn btn-primary mt-3 ml-4"
                            >
                              Update
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {deleteStatus ? (
            <Button
              variant="primary"
              onClick={(e) => {
                deleteBanner(e);
              }}
            >
              Delete
            </Button>
          ) : (
            <>
              {updateStatus ? null : (
                <Button
                  variant="primary"
                  onClick={(e) => {
                    saveBanner(e);
                  }}
                >
                  submit
                </Button>
              )}
            </>
          )}
        </Modal.Footer>
      </Modal>
      <div>
        <div style={{ padding: 20 }} className="flex-container">
          <div>
            <div>
              <button
                className="btn btn-primary float-right"
                onClick={handleShow}
              >
                Add Training
              </button>
            </div>
            <Table>
              <thead>
                <div className="row">
                  <div className="col-sm-2">
                    <strong>Header</strong>
                  </div>
                  <div className="col-sm-2">
                    <strong>Description</strong>
                  </div>
                  <div className="col-sm-2">
                    <strong>Image</strong>
                  </div>
                  <div className="col-sm-2">
                    <strong>Url</strong>
                  </div>
                  <div className="col-sm-2">
                    <strong>To</strong>
                  </div>
                </div>
              </thead>
            </Table>

            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <>
                {training &&
                  training.map((word) => {
                    return (
                      <Card
                        style={{
                          color: "white",
                          background:
                            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
                        }}
                      >
                        <Card.Body>
                          <div className="row">
                            <div className="col-sm-2 mt-5">
                              {word.Header ? (
                                <div key={word._id} className="flex-item">
                                  {word.Header}
                                </div>
                              ) : (
                                <div className="flex-item">----</div>
                              )}
                            </div>
                            <div className="col-sm-2 mt-4">
                              <div className="flex-item">
                                {word.Description}
                              </div>
                            </div>
                            <div className="col-sm-2">
                              <div
                                style={{
                                  marginTop: "5px",
                                  width: 220,
                                  height: 100,
                                  aspectRatio: 1 * 1.4,
                                }}
                                className="col-sm-12"
                              >
                                <img
                                  style={{
                                    resizeMode: "cover",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                  class="img-fluid"
                                  alt=""
                                  src={word.Image}
                                />
                              </div>
                            </div>
                            <div className="col-sm-2 mt-4">
                              <div className="flex-item">{word.Url}</div>
                            </div>
                            <div className="col-sm-1 mt-4">
                              <div className="flex-item">{word.To}</div>
                            </div>
                            <div className="mt-4">
                              <button
                                onClick={() => {
                                  setUploadStatus(false);
                                  setBannerId(word._id);
                                  setUpdateStatus(true);
                                  setShow(true);
                                  setDeleteStatus(false);
                                  setUrl(word.Url);
                                  setDescription(word.Description);
                                  setHeader(word.Header);
                                  setImageData(word.Image);
                                  setBannerImageKey(word.ImageKey);
                                }}
                                className="btn btn-primary "
                              >
                                Update
                              </button>
                              <button
                                onClick={() => {
                                  setBannerId(word._id);
                                  setDeleteStatus(true);
                                  setShow(true);
                                }}
                                className="btn btn-primary ml-2"
                              >
                                delete
                              </button>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    );
                  })}
                {!training && (
                  <Alert
                    variant="success"
                    className="alert-dismissible fade show text-center"
                  >
                    Add Training
                  </Alert>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
}
